import { Injectable } from '@angular/core';

import { BookingSession } from '../models';

@Injectable({
  providedIn: 'root',
})
export class BookingSessionService {
  private readonly SESSION_KEY = 'patientAppointmentBookingSession';
  private readonly SESSION_TTL = 30 * 60 * 1000; // 30 minutes

  save(session: BookingSession): void {
    const data = {
      ...session,
      expiresAt: Date.now() + this.SESSION_TTL,
      lastUpdated: Date.now(),
    };
    sessionStorage.setItem(this.SESSION_KEY, JSON.stringify(data));
  }

  load(): BookingSession | null {
    const item = sessionStorage.getItem(this.SESSION_KEY);
    if (!item) {
      return null;
    }

    try {
      const session = JSON.parse(item);

      // Check expiration
      if (Date.now() > session.expiresAt) {
        this.clear();
        return null;
      }

      return session;
    } catch (error) {
      // Error loading session, clear and return null
      this.clear();
      return null;
    }
  }

  clear(): void {
    sessionStorage.removeItem(this.SESSION_KEY);
  }

  isExpired(): boolean {
    const session = this.load();
    return session === null;
  }
}
